import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthService } from '../../auth/services/auth.service';
import { AuthResponse } from '../../auth/models';
import { ApplicationDialog } from '../../shared/base';
import { PageWrapperComponent } from '../../shared/components/page-wrapper';
import { WebsiteEndpoints } from '../api';
import { UserRole } from '../../auth/enums';

@Component({
    selector: 'app-login',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, PageWrapperComponent],
    templateUrl: './login.component.html',
    styleUrl: './login.component.sass',
})
export class LoginComponent extends ApplicationDialog {
    @Input() userType?: string;
    loginForm: FormGroup = new FormGroup({
        email: new FormControl('', [Validators.required]),
        password: new FormControl('', [Validators.required]),
        rememberMe: new FormControl(false, []),
    });
    loading = false;
    isLogin = false;
    private authService: AuthService = inject(AuthService);

    onSubmit() {
        if (this.loginForm.valid) {
            this.loading = true;

            this.request<AuthResponse>(
                this.http.post<{ email: string; password: string }, AuthResponse>(
                    WebsiteEndpoints.LOGIN,
                    this.loginForm.value,
                    undefined,
                    {
                        headers: { noauth: 'true' },
                    },
                ),
                {
                    showToast: true,
                    onSuccess: async (user) => {
                        if (user) {
                            await this.authService.saveSession(user);
                            this.closeDialog('success', null);
                            this.loading = false;
                            if (
                                user.user?.role === UserRole.ADMIN ||
                                user.user?.role === UserRole.CTO
                            ) {
                                this.navigateTo('/dashboard');
                            } else {
                                this.navigateTo('/dashboard');
                            }
                        }
                    },
                    onError: () => {
                        this.loading = false;
                    },
                },
            );
        }
    }
}
